bz_app.controller('PropertyCtrl', [
  '$scope',
  '$timeout',
  'contentInjectService',
  'positionService',
  function ($scope, $timeout, contentInjectService, positionService) {
    $scope.property = null
    $scope.neighborhoodProperties = null
    $scope.neighborhoodPropertiesDetails = null
    $scope.photosData = null
    $scope.init = function (data) {
      $scope.property = data.property

      if (data.neighborhoodProperties)
        $scope.neighborhoodProperties = data.neighborhoodProperties
      if (data.neighborhoodPropertiesDetails)
        $scope.neighborhoodPropertiesDetails =
          data.neighborhoodPropertiesDetails
      if (data.photosData) $scope.photosData = data.photosData

      $scope.$on('property-photos-not-loaded', function () {
        angular.element('#photos').hide()
      })

      // only load map when it is scrolled into view
      positionService.triggerInViewport(
        '.permit-map-wrapper',
        () => {
          Track.sendGa('Google Map', 'property page')

          if ($scope.isValidLocation()) {
            contentInjectService.neighborhoodProjects($scope)
          }
        },
        { checkForMap: true }
      )

      // only load below-fold content after the header map loaded
      $scope.$on('property-header-map-loaded', function () {
        // inject below-fold directives
        $timeout(function () {
          contentInjectService.projectForm($scope)
          contentInjectService.photoRibbon($scope)
        }, 2000)
      })
    }

    $scope.scrollTo = function (selector) {
      angular.element(selector).animatescroll({ padding: 50 })
    }

    $scope.isValidLocation = function () {
      if (
        !$scope.property.latitude ||
        $scope.property.latitude == '0.0' ||
        !$scope.property.longitude ||
        $scope.property.longitude == '0.0'
      ) {
        return false
      } else return true
    }
  },
])
